// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react';

import Svg, { SvgProps } from '../Svg';

const EyeRegular: React.FC<SvgProps> = (props) => (
  <Svg width="24" height="24" {...props} viewBox="0 0 24 24">
    <g
      id="グループ_901"
      data-name="グループ 901"
      transform="translate(-1004 3159)"
    >
      <rect
        id="長方形_515"
        data-name="長方形 515"
        width="24"
        height="24"
        transform="translate(1004 -3159)"
        fill="none"
      />
      <path
        id="eye-regular"
        d="M5.77,39.885a4.561,4.561,0,0,1,4.616-4.506,4.507,4.507,0,1,1,0,9.011A4.561,4.561,0,0,1,5.77,39.885ZM10.385,42.7a2.817,2.817,0,1,0,0-5.632h-.1a1.373,1.373,0,0,1,.1.563,2.283,2.283,0,0,1-2.308,2.253,1.467,1.467,0,0,1-.577-.1v.07A2.857,2.857,0,0,0,10.385,42.7ZM3.441,34.837A10.273,10.273,0,0,1,10.385,32a10.277,10.277,0,0,1,6.945,2.837,13.639,13.639,0,0,1,3.35,4.615,1.1,1.1,0,0,1,0,.866,14.273,14.273,0,0,1-3.35,4.615,10.27,10.27,0,0,1-6.945,2.837,10.267,10.267,0,0,1-6.945-2.837A14.328,14.328,0,0,1,.089,40.318a1.1,1.1,0,0,1,0-.866,13.689,13.689,0,0,1,3.352-4.615Zm6.945-1.148a8.543,8.543,0,0,0-5.766,2.383,12.159,12.159,0,0,0-2.837,3.812A12.525,12.525,0,0,0,4.619,43.7a8.543,8.543,0,0,0,5.766,2.383A8.543,8.543,0,0,0,16.151,43.7a13.114,13.114,0,0,0,2.838-3.812,12.712,12.712,0,0,0-2.838-3.812,8.543,8.543,0,0,0-5.766-2.383Z"
        transform="translate(1005.615 -3186.885)"
      />
    </g>
  </Svg>
);

EyeRegular.displayName = 'EyeRegular';

export default EyeRegular;
